(function(){
  function bind(root){
    if(!root||root.dataset.wlCatBound==='1')return;
    root.dataset.wlCatBound='1';
    var scroller=root.querySelector('.wl-hscroll'),dots=root.querySelectorAll('.wl-cat-dot'),tiles=root.querySelectorAll('.wl-cat-tile');
    if(!scroller||tiles.length<2)return;
    var idx=0,timer=null,resume,raf=0;
    function isCarousel(){return(scroller.scrollWidth-scroller.clientWidth)>4}
    function setActive(i){dots.forEach(function(d,k){d.classList.toggle('is-active',k===i)})}
    function advance(){if(!isCarousel())return;var next=(idx+1)%tiles.length;scroller.scrollTo({left:tiles[next].offsetLeft,behavior:'smooth'})}
    function stop(){if(timer){clearInterval(timer);timer=null}}
    function start(){stop();if(isCarousel())timer=setInterval(advance,4000)}
    scroller.addEventListener('scroll',function(){
      if(raf)return;
      raf=requestAnimationFrame(function(){
        raf=0;var left=scroller.scrollLeft,best=0,min=Infinity;
        for(var i=0;i<tiles.length;i++){var d=Math.abs(tiles[i].offsetLeft-left);if(d<min){min=d;best=i}}
        if(best!==idx){idx=best;setActive(best)}
      });
    },{passive:true});
    function pause(){stop();clearTimeout(resume);resume=setTimeout(start,5000)}
    dots.forEach(function(d,i){d.addEventListener('click',function(){scroller.scrollTo({left:tiles[i].offsetLeft,behavior:'smooth'});pause()})});
    ['touchstart','pointerdown','wheel'].forEach(function(ev){scroller.addEventListener(ev,pause,{passive:true})});
    start();
  }
  function boot(){document.querySelectorAll('[id^="wl-cat-"]').forEach(bind)}
  if(window.__wlCategoriesInit){window.__wlCategoriesInit();return}
  window.__wlCategoriesInit=boot;
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){requestAnimationFrame(boot)});else requestAnimationFrame(boot);
  document.addEventListener('shopify:section:load',boot);
})();
